'use client';

import React from 'react';
import { LeftNavigationPanelView, LeftNavigationPanelViewProps } from './LeftNavigationPanelView';

export type LeftNavigationPanelProps = LeftNavigationPanelViewProps;

export const LeftNavigationPanel: React.FC<LeftNavigationPanelProps> = (props) => {
  return <LeftNavigationPanelView {...props} />;
};
